import { makeAutoObservable, observable } from 'mobx'
import React from 'react'
import { WindowClickSignaler } from './utils'

export class SingleMenuDropdownStore {
  isOpen: boolean = false
  _hardClosed: boolean = false
  _anchorButtonRef?: React.RefObject<HTMLDivElement | HTMLButtonElement>
  _bodyRef?: React.RefObject<HTMLDivElement>
  _windowClickHandlers = new Set<WindowClickSignaler>()
  _leftOffset: number = 0
  _topOffset: number = 0
  constructor(readonly parentStore: SingleMenuDropdownStore | null) {
    makeAutoObservable(this, {
      isOpen: observable,
    })
  }
  setAnchorButtonRef = (buttonRef: typeof this._anchorButtonRef) => {
    this._anchorButtonRef = buttonRef
  }
  setDropdownBodyRef = (bodyRef: typeof this._bodyRef) => {
    this._bodyRef = bodyRef
  }
  hardOpen = () => {
    this._hardClosed = false
    this.setOpen(true)
  }
  softOpen = () => {
    if (!this._hardClosed) {
      this.setOpen(true)
    }
  }
  hardClose = () => {
    this._hardClosed = true
    this.setOpen(false)
  }
  softClose = () => {
    this.setOpen(false)
  }
  hardToggle = () => {
    if (this.isOpen) {
      this.hardClose()
    } else {
      this.hardOpen()
    }
  }
  registerWindowClickSignaler = (wcs: WindowClickSignaler) => {
    this._windowClickHandlers.add(wcs)
    this.parentStore?.registerWindowClickSignaler(wcs)
  }
  unregisterWindowClickSignaler = (wcs: WindowClickSignaler) => {
    this._windowClickHandlers.delete(wcs)
    this.parentStore?.unregisterWindowClickSignaler(wcs)
  }
  handleMouseBlur = (e: MouseEvent) => {
    if (!this.isOpen) return
    for (const handler of this._windowClickHandlers) {
      if (handler(e)) return
    }
    if (this.isOpen) {
      this.softClose()
    }
    this._hardClosed = false
  }
  // Debouncing this causes a lot of problems with DropdownOrchestration
  private setOpen = (open: boolean) => {
    this.isOpen = open
  }
}

export const SingleMenuDropdownContext = React.createContext<SingleMenuDropdownStore | null>(null)
